// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"video-player_videoWrapper__UEP4d"};